// Global Components
import * as React from 'react';

// Types
type $Props = {
  items: Array<[number, number]>;
};

const EmptyListView = function ({
  items,
}: $Props) {
  return (
    <div className={'EmptyList w-full'}>
      {items.map(([height, padding]: [number, number], i) => (
        <div
          className={'bg-white rounded-lg px-5 mb-2'}
          key={`row_${String(i)}`}
          style={{
            paddingBottom: `${String(padding)}rem`,
            paddingTop: `${String(padding)}rem`,
          }}
        >
          <div
            className={'EmptyList-empty'}
            style={{
              height: `${String(height)}rem`,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default EmptyListView;
